import PasswordField from './password-field.vue';

export default PasswordField;
